module.exports = __webpack_public_path__ + "img/evaluateConfig-active.65b77a9c.svg";